// extracted by mini-css-extract-plugin
export var dropdownIcon = "_q9-6";
export var imgContainer = "_q9-3";
export var menuIcon = "_q9-5";
export var pillWrapper = "_q9-2";
export var pillsContainer = "_q9-1";
export var subscriptionCard = "_q9-0";
export var subscriptionLogo = "_q9-4";